import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getVendorQuery = (categoryId) => {
    const config = {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}` || null
        }
    };
    return axios.get(`${apiurl?.getVendorCategory}/${categoryId}`, config);
};

export default getVendorQuery;
